import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 35.054 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, white)",
      "stroke-opacity": ".2",
      d: "M17.527 35.5c9.404 0 17.027-7.835 17.027-17.5S26.931.5 17.527.5.5 8.335.5 18s7.623 17.5 17.027 17.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--fill-0, white)",
      "fill-opacity": ".5",
      d: "m15.478 24.653.247-3.916 6.771-6.406c.3-.287-.061-.425-.458-.175L13.68 19.7l-3.615-1.204c-.776-.23-.785-.796.176-1.203l14.08-5.703c.644-.304 1.261.168 1.014 1.204l-2.398 11.858c-.167.842-.652 1.046-1.322.657l-3.65-2.832-1.755 1.786c-.203.213-.37.389-.732.389"
    }, null, -1)
  ]))]))
}
export default { render: render }